import { localDateTime } from "../Helper";

export const Type = {
	Default: 'Parent',
	Bulk: 'Bulk',
	Basket: 'Basket',
	Chained: 'Chained',
	Cross: 'Cross',
	Joint: 'Joint'
}

export const ProductType = {
	BOND: 'Bonds',
	EQUITY: 'Equity',
	OPTION: 'Options',
	MFUNDS: 'Mutual Funds',
	MMARKET: 'Money Market',
	FOREX: 'Forex',
	REPO: 'Repo',
	FUTURE: 'Future',
}

export const ProductTypeFunds = {
	MFUNDS: 'Mutual Funds',
}

export const OrderPriceType = {
	MARKET: 'Market',
	LIMIT: 'Limit',
	STOP: 'Stop',
	STOPLIMIT: 'StopLimit',
	MARKETONOPEN: 'MarketOnOpen',
	MARKETONCLOSE: 'MarketOnClose'
}

export const TimeFrame = {
	DAY: 'DAY',
	GTC: 'GTC',
	GTD: 'GTD',
	OPG: 'OPG'
}

export const TimeFrameIsSelectable = (tf) => (tf != 'OPG')

export const AccountType = {
	CASH: 1,
	MARGIN: 2
}

export const OrderStatus = {
	ROUTED: 'PendingNew',
    FILLED: 'Filled',
    CANCEL_PENDING: 'PendingCancel',
    ANNULLED: 'Stopped',
    CANCELED: 'Canceled',
    PART: 'Partial',
    PART_FILLED: 'PartiallyFilled',
	REJECTED: 'Rejected',
	EXPIRED: 'Expired',
    AMENDING: 'PendingReplace',
    ACKED: 'New',
    PARKED: 'Parked',
    AUTH_WAIT: 'WaitingAuthorization',
    CROSSING: 'Crossing',
    REALLOCATING: 'Reallocating'
}

export const OrderDayStatus = {
	NEW: 'New',
	ASSIGNED: 'Assigned',
	LOCKED: 'Locked',
	BOOKED: 'Booked',
	ROLLEDBACK: 'RolledBack',
}

export const OrderAction = {
    ACK: 'Ack',
    REJECT: 'Reject',
    ACCEPT_CANCEL_REPLACE: 'AcceptCancelReplace',
    REJECT_CANCEL_REPLACE: 'RejectCancelReplace',
    CANCEL: 'Cancel',
    MOVE_TO_WORKING: 'MoveToWorking',
    MOVE_TO_COMPLETED: 'MoveToCompleted',
	MOVE_TO_TODO: 'MoveToTodo',
	LOCK: 'Lock',
}

export const SettleInstAction = {
    MATCH: 'Match',
    SPLIT: 'Split',
	UNMATCH: 'Unmatch',
	EDIT: 'Edit',
	SEND_EMAIL: 'SendEmail',
}

export const TradeAction = {
    CONFIRM: 'Confirm',
	REJECT: 'Reject',
	CANCEL: 'Cancel'
}

export const TradeStatus = {
	NEW: 'New',
    CONFIRMATION_SENT: 'ConfirmationSent',
    MATCHED: 'Matched',
    UNMATCHED: 'Unmatched',
    BOOKED: 'Booked',
    CANCELED: 'Canceled',
}

export const MarketType = {
  OTC: "OTC",
  EXCHANGE: "Exchange",
};

export const SettlementInstructionStatus = {
	NEW: 'New',
    UNMATCHED: 'Unmatched',
    MATCHED: 'Matched',
	BOOKED: 'Booked',
	SETTLEMENT_FAILURE: 'SettlementFailure',
	SETTLEMENT_COMPLETION: 'SettlementCompletion',
    CANCELED: 'Canceled',
}

export const SettlementInstructionAccount = {
    IN_BALANCE: 'In Balance',
    CUSTOMER: 'Customer',
	TRADING: 'Trading',
}

export const Mode = {
	EDIT: 2,
	READONLY: 3,
	QUOTE: 4,
	PRECHECK: 5,
	CONFIRM: 6,
	EDIT_COMMISSION: 7,
	EXECUTE: 8,
	REALLOCATE: 9
}

export const ProcessingMode = {
	Default: 'Default',
	Automated: 'Automated',
	HighTouch: 'HighTouch',
};

export const CommissionType = {
	FaceValueCash: 'FaceValueCash',
	PrincipalPercentage: 'PrincipalPercentage'
}

export const getProductTypeName = (productType) => {
	switch (productType) {
		case ProductType.BOND:
			return 'Bond';
		case ProductType.EQUITY:
			return 'Equity';
		case ProductType.OPTION:
			return 'Option';
		case ProductType.MFUNDS:
			return 'M-Funds';
		case ProductType.FOREX:
			return 'FX';	
		case ProductType.MMARKET:
			return 'M-Market';	
		case ProductType.REPO:
			return 'Repo';	
		case ProductType.FUTURE:
			return 'Future';	
	}
}

export const getOrderTypeName = (orderType) => {
	switch (orderType) {
		case OrderPriceType.MARKET:
			return 'Market';
		case OrderPriceType.MARKETONOPEN:
			return 'Market Open';
		case OrderPriceType.MARKETONCLOSE:
			return 'Market Close'
		case OrderPriceType.LIMIT:
			return 'Limit';
		case OrderPriceType.STOP:
			return 'Stop';	
		case OrderPriceType.STOPLIMIT:
			return 'Stop-Limit';	
	}
}

export const getTimeFrameName = (timeFrame) => {
	switch (timeFrame) {
		case TimeFrame.DAY:
			return 'DAY';
		case TimeFrame.GTC:
			return 'GTC';
		case TimeFrame.GTD:
			return 'GTD';
		case TimeFrame.OPG:
			return 'OPG';
	}
}

export const getAccountTypeName = (accountType) => {
	switch (accountType) {
		case AccountType.CASH:
			return 'Cash';
		case AccountType.MARGIN:
			return 'Margin';
	}
}

export const getStatusName = (status) => {
	switch (status) {
		case OrderStatus.AMENDING:
			return 'AMENDING';
		case OrderStatus.CANCEL_PENDING:
			return 'CLX PEND';
		case OrderStatus.ROUTED:
			return 'ROUTED';
		case OrderStatus.ACKED:
			return 'ACKED';
		case OrderStatus.PART:
			return 'PART';
		case OrderStatus.FILLED:
			return 'FILLED';
		case OrderStatus.REJECTED:
			return 'REJECTED';
		case OrderStatus.EXPIRED:
			return 'EXPIRED';
		case OrderStatus.ANNULLED:
		case OrderStatus.CANCELED:
			return "CANCELED";
		case OrderStatus.PART_FILLED:
			return "P-FILLED";
		case OrderStatus.PARKED:
			return "PARKED";	
		case OrderStatus.AUTH_WAIT:
			return "AUTH. WAIT";
		case OrderStatus.CROSSING:
			return "CROSSING";
		case OrderStatus.REALLOCATING:
			return "REALLOCATING";
		default:
			return 'NOT DEFINED';
	}
}

export const getTradeStatusName = (status) => {
	switch (status) {
		case TradeStatus.NEW:
			return 'NEW';
		case TradeStatus.CONFIRMATION_SENT:
			return 'CONFIRM SENT';
		case TradeStatus.MATCHED:
			return 'MATCHED';
		case TradeStatus.UNMATCHED:
			return 'UNMATCHED';
		case TradeStatus.BOOKED:
			return 'BOOKED';
		case TradeStatus.CANCELED:
			return 'CANCELED';
		default:
			return 'NOT DEFINED';
	}
}

export const getCommissionItems = (productType) => {
	switch (productType) {
		case ProductType.BOND: 
		case ProductType.EQUITY: 
		case ProductType.OPTION: 
		case ProductType.FOREX: 
		case ProductType.MMARKET: 
		case ProductType.REPO: 
		case ProductType.FUTURE: 
		case ProductType.MFUNDS: 
			return [
				{id: 'FaceValueCash', description: '$ Cash'},
				{id: 'PrincipalPercentage', description: '% Principal'}
			]
	}	
}

export const getOrderStats = (order) => {
	let qtyPending = order.OrderQuantity;
	let executedQuantity = 0;
	let sum = 0;

	const isCash = order.OrderQuantityIsCash;
	const decimalPlaces = order.SubAssetClassDecimalPlaces;
  	const parValue = parseFloat(order.AssetParValue) || 1.0;

	order.Childs && order.Childs.forEach((child) => {
		child.Executions && child.Executions.forEach((e) => {
			e.ExecutionDate = localDateTime(e.ExecutionDate);
			if (isCash) {
        qtyPending -=
          parseFloat(e.ExecutionQuantity) *
          parseFloat(e.ExecutionPrice) *
          parValue;
      } else {
        qtyPending -= parseFloat(e.ExecutionQuantity);
      }
			executedQuantity += parseFloat(e.ExecutionQuantity);
			
			sum += parseFloat(e.ExecutionQuantity) * parseFloat(e.ExecutionPrice);
		})
	})

	if (order.AssetClassForm === 'Repo') {
		return {
			pending: order.OrderStatus === 'Filled' ? 0: 1,
			avg:  1
		}
	}

	return {
		pending: order.AssetClassForm === 'Forex' ? qtyPending : Number(qtyPending).toFixed(decimalPlaces),
		avg:  executedQuantity != 0 ? (sum/executedQuantity).toFixed(2) : '-'
	}
}

export const getBaseAndPriceCurrencies = (settlementCurrencies, tradeCurrencySymbol, settleCurrencySymbol) => {
	let baseCurrency = settleCurrencySymbol;
	let priceCurrency = tradeCurrencySymbol;
	if (settlementCurrencies) {
		const settlementCurrencyInfo = settlementCurrencies.find(
			(c) => {
                if (c.description) {
                    return c.description == settleCurrencySymbol;
                } else {
                    if (c.currencyInfo) {
                        return c.currencyInfo.currencyISO == settleCurrencySymbol;
                    }
                }
            }
		);
		const settlementCurrencyMultiplies = settlementCurrencyInfo && settlementCurrencyInfo.multiplies;

		baseCurrency = settlementCurrencyMultiplies ? tradeCurrencySymbol : settleCurrencySymbol;
		priceCurrency = settlementCurrencyMultiplies ? settleCurrencySymbol : tradeCurrencySymbol;
	}
	return { baseCurrency, priceCurrency };
}

export const getOrderActionByDrag = ({order, source, destination }) => {
  let action;

  const canMoveToTodo = [
    OrderStatus.ACKED,
    OrderStatus.REJECTED,
    OrderStatus.CANCELED,
  ].includes(order.OrderStatus);

  const canMoveToWorking = [
    OrderStatus.ROUTED,
    OrderStatus.REJECTED,
    OrderStatus.CANCELED,
    OrderStatus.PART_FILLED,
  ].includes(order.OrderStatus);

  const canMoveToCompleted = [
    OrderStatus.ROUTED,
    OrderStatus.ACKED,
    OrderStatus.PART,
    OrderStatus.AMENDING, // Amending is canceled
    OrderStatus.CANCEL_PENDING, // cancel is accepted
  ].includes(order.OrderStatus);

  // Is from trader desk move order throw columns
  if (source === destination) {
    action = undefined;
  } else {
    switch (destination) {
      case 'todo':
        if (canMoveToTodo) {
          action = OrderAction.MOVE_TO_TODO;
        } else {
          action = undefined;
        }
        break;
      case 'working':
        if (canMoveToWorking) {
          action = OrderAction.MOVE_TO_WORKING;
        } else {
          action = undefined;
        }
        break;
      case 'completed':
        if (canMoveToCompleted) {
          action = OrderAction.MOVE_TO_COMPLETED;
        } else {
          action = undefined;
        }
        break;
      default:
        action = undefined;
    }
  }

  return action;
}

export const getOptionFieldsFromTicker = (order) => {
	const optsRegExp = /(\w{1,6})((\d{2})(\d{2})(\d{2}))([CP])((\d{5})(\d{3}))/;

	const match = optsRegExp.exec(order.AssetTicker || order);

	const AssetTicker = match[1];
	const isCall = (match[6].toUpperCase() == 'C') ? 1 : 2;
	const expiration = toDateLocal(new Date('20' + match[3], match[4]-1, match[5], 0, 0, 0, 0));
	const strikePrice = parseInt(match[8]) + parseInt(match[9]) / 1000;

	return {
		AssetTicker,
		isCall,
		expiration,
		strikePrice
	}
	
}

export const getOptionsTickerFromFields = (order) => {
	const parseExpiration = (e) => `${e[2]}${e[3]}${e[5]}${e[6]}${e[8]}${e[9]}`;

	const parseCallPut = (c) => c == 1 ? 'C' : 'P';

	const parseStrike = (s) => s.toFixed(3).toString().replace('.','').padStart(8,'0');

	return `${order.AssetTicker}${parseExpiration(order.expiration)}${parseCallPut(order.isCall)}${parseStrike(order.strikePrice)}`
}

function toDateLocal(date) {
	var
		ten = function(i) {
			return (i < 10 ? '0' : '') + i;
		},
		YYYY = date.getFullYear(),
		MM = ten(date.getMonth() + 1),
		DD = ten(date.getDate())
	;
	
	return YYYY + '-' + MM + '-' + DD;
}